import { CLASSIFICATION_MARKET_TARGET_ATTR_NAME } from '../../../constants';

const WEEKLY_REPORT_LOGICAL_ATTRIBUTE_ID = 1;
const WEEKLY_REPORT_CLASSIFICATION_NAME = CLASSIFICATION_MARKET_TARGET_ATTR_NAME;

type WeeklyReportClassificationMeta = {
  attr_id?: unknown;
  logical_attr_id?: unknown;
  attr_name?: unknown;
  label?: unknown;
} | null | undefined;

const normalizeName = (value: unknown): string =>
  String(value ?? '')
    .normalize('NFKC')
    .replace(/\s+/g, '')
    .toLowerCase();

/**
 * 課ごとに枝番化された attr_id でも、週報分類として同じ公開範囲UIを表示する。
 * logical_attr_id は現行API、名称判定は旧APIレスポンスとの互換用。
 */
export const isWeeklyReportClassificationSetting = ({
  settingId,
  title,
  meta,
}: {
  settingId?: unknown;
  title?: unknown;
  meta?: WeeklyReportClassificationMeta;
}): boolean => {
  const rawLogicalAttributeId = meta?.logical_attr_id;
  if (
    rawLogicalAttributeId !== undefined &&
    rawLogicalAttributeId !== null &&
    String(rawLogicalAttributeId).trim() !== ''
  ) {
    const logicalAttributeId = Number(rawLogicalAttributeId);
    if (Number.isFinite(logicalAttributeId)) {
      return logicalAttributeId === WEEKLY_REPORT_LOGICAL_ATTRIBUTE_ID;
    }
  }

  if (Number(meta?.attr_id ?? settingId) === WEEKLY_REPORT_LOGICAL_ATTRIBUTE_ID) {
    return true;
  }

  const weeklyReportName = normalizeName(WEEKLY_REPORT_CLASSIFICATION_NAME);
  return [meta?.attr_name, meta?.label, title]
    .some((value) => normalizeName(value) === weeklyReportName);
};
